import request from '@/utils/request'
import { StringUtil } from "@/utils/base/StringUtil";

// 查询用户列表
export function listUser(query) {
  return request({
    url: '/system/user/list',
    method: 'get',
    params: query
  })
}

// 用户权限查询
export function listAnonymousUser(query) {
  return request({
    url: '/system/dataScope/listAnonymous',
    method: 'get',
    params: query
  })
}

// 查询用户详细
export function getUser(pkUser) {
  return request({
    url: '/system/user/' + StringUtil.parseString(pkUser),
    method: 'get'
  })
}

// 新增用户
export function addUser(data) {
  return request({
    url: '/system/user',
    method: 'post',
    data: data
  })
}

// 修改用户
export function updateUser(data) {
  return request({
    url: '/system/user',
    method: 'put',
    data: data
  })
}

// 删除用户
export function delUser(pkUser) {
  return request({
    url: '/system/user/' + pkUser,
    method: 'delete'
  })
}

// 用户密码重置
export function resetUserPwd(pkUser, password) {
  const data = {
    pkUser,
    password
  }
  return request({
    url: '/system/user/resetPwd',
    method: 'put',
    data: data
  })
}

// 用户状态修改
export function changeUserState(pkUser, state) {
  const data = {
    pkUser,
    state
  }
  return request({
    url: '/system/user/changeState',
    method: 'put',
    data: data
  })
}

// 查询用户个人信息
export function getUserProfile() {
  return request({
    url: '/system/user/profile',
    method: 'get'
  })
}

// 修改用户个人信息
export function updateUserProfile(data) {
  return request({
    url: '/system/user/profile',
    method: 'put',
    data: data
  })
}

// 用户密码重置
export function updateUserPwd(oldPassword, newPassword) {
  const data = {
    oldPassword,
    newPassword
  }
  return request({
    url: '/system/user/profile/updatePwd',
    method: 'put',
    params: data
  })
}
// 用户密码重置
export function updateWebUserPwd(userName, oldPassword, newPassword) {
  const data = {
    userName,
    oldPassword,
    newPassword
  }
  return request({
    // url: '/system/user/profile/updateWebPwd',
    url: '/auth/updateWebPwd',
    method: 'post',
    data
  })
}

// 用户头像上传
export function uploadAvatar(data) {
  return request({
    url: '/system/user/profile/avatar',
    method: 'post',
    data: data
  })
}

// 查询授权角色
export function getAuthRole(pkUser) {
  return request({
    url: '/system/user/authRole/' + pkUser,
    method: 'get'
  })
}

// 保存授权角色
export function updateAuthRole(data) {
  return request({
    url: '/system/user/authRole',
    method: 'put',
    params: data
  })
}

// 查询用户职责列表
export function listUserPost(query) {
  return request({
    url: '/system/user/userPost',
    method: 'get',
    params: query
  })
}

// 修改用户职责
export function updateUserPost(data) {
  return request({
    url: '/system/user/userPost',
    method: 'put',
    data: data
  })
}

// 查询用户列表-无菜单权限
export function pageCom(query) {
  return request({
    url: '/system/user/pageCom',
    method: 'get',
    params: query
  })
}

// 获取当前登录人
export function getLoginUser() {
  return request({
    url: '/system/user/getLoginUser',
    method: 'get'
  });
}
